import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)
let constantRoutes = [{
  path: '/',
  component: () =>
    import('@/Layout.vue'),
  children: [{
    path: '',
    name: 'total',
    component: () =>
      import('@/pages/resourcesListPage.vue')
  }]
},
{
  path: '/resources',
  name: '资源池汇总',
  component: () =>
      import('@/Layout.vue'),
  children: [{
    path: 'total',
    name: 'total',
    // meta: { auth: { 0: 1100, 1: 1 } },
    component: () =>
        import('@/pages/resourcesPage.vue')
  },
  {
    path: 'hids',
    name: 'hids',
    // meta: { auth: { 0: 1100, 1: 1 } },
    component: () =>
          import('@/pages/hidsPage')

  },
  {
    path: 'list',
    name: 'list',
    component: () =>
          import('@/pages/resourcesListPage.vue')
  },
  {
    path: 'add',
    name: 'addresources',
    meta: {auth: {0: 1001, 1: 1}},
    component: () =>
          import('@/views/resources/addResources.vue')
  },
  {
    path: 'detail',
    name: 'detail',
    component: () =>
          import('@/pages/resourceDetailPage.vue')
  }
  ]
},
{
  path: '/bill',
  name: '账单中心',
  component: () =>
      import('@/Layout.vue'),
  children: [{
    path: 'total',
    name: 'total',
    meta: {auth: {0: 1204, 1: 1}},
    component: () =>
        import('@/pages/billPage.vue')
  },
  {
    path: 'accountRules',
    name: 'accountRules',
    meta: {},
    component: () =>
          import('@/pages/accountRulesPage.vue')
  },
  {
    path: 'billList',
    name: 'billList',
    meta: {auth: {0: 1205, 1: 1}},
    component: () =>
          import('@/pages/billListPage.vue')
  },
  {
    path: 'mybill',
    name: 'mybill',
    meta: {},
    component: () =>
          import('@/pages/mybillPage.vue')
  },
  {
    path: 'billBudget',
    name: 'billBudget',
    meta: {auth: {0: 1207, 1: 1}},
    component: () =>
          import('@/pages/billBudgetPage.vue')
  }
  ]
},
{
  path: '/users',
  component: () =>
      import('@/Layout.vue'),
  children: [{
    path: 'list',
    name: 'userList',
    meta: {auth: {0: 1400, 1: 1}},
    component: () =>
        import('@/pages/userListPage.vue')
  }]
},
{
  path: '/auth',
  component: () =>
      import('@/Layout.vue'),
  children: [{
    path: 'manage',
    name: 'authmanage',
    component: () =>
        import('@/pages/authManagePage.vue')
  },
  {
    path: 'teams',
    name: 'teams',
    meta: {auth: {0: 1700, 1: 1}},
    component: () =>
          import('@/pages/teamsPage.vue')
  }
  ]
},
{
  path: '/app',
  name: '应用管理',
  component: () => import('@/Layout.vue'),
  children: [
    {
      path: 'applist',
      name: 'applist',
      component: () => import('@/pages/AppManage/appList')

    },
    {
      path: 'appMonitoring',
      name: 'appMonitoring',
      component: () => import('@/pages/AppManage/appMonitoring')
    }, {
      path: 'appconfig',
      name: 'appconfig',
      component: () => import('@/pages/AppManage/appconfig'),
      children: [
        {
          path: 'message',
          name: 'message',
          component: () => import('@/pages/AppManage/List/messagePage')
        },

        {
          path: 'login',
          name: 'login',
          component: () => import('@/pages/AppManage/List/loginPage')
        }
      ]

    }
  ]
},
{
  path: '/system',
  name: '系统设置',
  component: () =>
      import('@/Layout.vue'),
  children: [{
    path: 'log',
    name: 'log',
    meta: {auth: {0: 1500, 1: 1}},
    component: () =>
        import('@/pages/logPage.vue')
  },
  {
    path: 'msg',
    name: 'message',
    component: () =>
          import('@/pages/msgPage.vue')
  },
  {
    path: 'create',
    name: 'createyun',
    meta: {auth: {0: 1800, 1: 1}},
    component: () =>
          import('@/pages/createCloudPage.vue')
  },
  {
    path: 'script',
    name: 'script',
    component: () =>
          import('@/pages/scriptManage.vue')
  }
  ]
},
{
  path: '/assets',
  component: () =>
      import('@/Layout.vue'),
  children: [{
    path: 'set',
    name: 'assetsSet',
    meta: {auth: {0: 1101, 1: 1}},
    component: () =>
        import('@/pages/assetsSetPage.vue')
  }]
},
{
  path: '/safey',
  component: () =>
      import('@/Layout.vue'),
  children: [{
    path: 'group',
    name: 'safey',
    meta: {auth: {0: 1101, 1: 1}},
    component: () =>
        import('@/pages/safeyPage.vue')
  }]
}
]

const createRouter = () =>
  new Router({
    mode: 'history',
    scrollBehavior: () => ({y: 0}),
    routes: constantRoutes
  })
const router = createRouter()
export default router



// WEBPACK FOOTER //
// ./src/router/index.js